export default "__VITE_ASSET__Dq5sn0mj__"